import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scoped.css';
import Text from '../../../components/fields/Text';
import { Field } from 'redux-form';
import Button from '../../../components/elements/Button';
export default function PermissionForm({
  handleSubmit = () => {},
  initialValues = {},
}) {
  const inputPropsPermission = {
    label: 'Nama Permission',
    placeholder: 'Nama Permission',
  };
  const inputPropsPath = {
    label: 'Path',
    placeholder: '/..',
  };
  const type = Object.keys(initialValues).length > 0 ? 'edit' : 'add';

  return (
    <form onSubmit={handleSubmit}>
      <p>Form {type === 'edit' ? 'Ubah' : 'Tambah'} Permission</p>
      <br />
      <div className={styles.desc}>
        {`Berikut ini adalah form yang digunakan untuk ${type === 'add' ? 'menambah' : 'merubah'} data`}{' '}
        <b>Permission.</b> Pastikan data yang anda inputkan sudah sesuai. Semua
        parameter pada <b>form ini wajib diisi.</b>
      </div>
      <br />
      <Field
        component={Text}
        inputProps={inputPropsPermission}
        name="permission"
        required={true}
      />
      <Field
        component={Text}
        inputProps={inputPropsPath}
        name="path"
        required={true}
      />
      <div className={styles.btnSaveContainer}>
        <Button className={styles.btnSave} fullWidth style={'blue'} type="submit">
          Simpan
        </Button>
      </div>
    </form>
  );
}

PermissionForm.propTypes = {
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  isOpen: PropTypes.bool,
  type: PropTypes.string,
};
